import { render, staticRenderFns } from "./StandSelectionSuccessful.vue?vue&type=template&id=0736fdd1"
import script from "./StandSelectionSuccessful.vue?vue&type=script&lang=js"
export * from "./StandSelectionSuccessful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports